/**
 * Created by Administrador on 15/05/2017.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .controller('itineraryListRevenueCtrl', itineraryListRevenueCtrl);

    itineraryListRevenueCtrl.$inject = ['linkService','itineraries','tabRevenue'];

    function itineraryListRevenueCtrl(linkService,itineraries,tabRevenue){
        var vm = this;
        vm.tabs = tabRevenue;
        vm.itineraries = (itineraries.data.itineraryEnable._embedded) ? itineraries.data.itineraryEnable._embedded.itineraries : [];
        vm.itineraryDisabled = [];
        vm.itinerariesDisable = (itineraries.data.itineraryDisable._embedded) ? itineraries.data.itineraryDisable._embedded.itineraries : [];
        vm.contItineraryDisable = (vm.itinerariesDisable).length;
        vm.listDisabled = false;
        vm.disabled = true;
        vm.hide = false;
        vm.linkService = linkService;

        vm.showDisabled = function(){
            vm.listDisabled = true;
            vm.disabled = false;
            vm.hide = true;
        }

        vm.hideDisabled = function(){
            vm.listDisabled = false;
            vm.disabled = true;
            vm.hide = false;
        }
    };

})();
